<template>
  <Panel
    class="intro-y"
    :title="$t('text.customerInfoBank')"
    :btnName="!disabled ? $t('label.increaseLimit') : null"
    @click="showModal"
  >
    <div class="flex flex-col sm:flex-row">
      <p class="mr-auto text-gray-600">{{ $t('text.nameOfCustomerBank') }}</p>
      <p class="font-medium">{{ customer.banks[0].bank.name }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.nameOfBankAccount') }}</p>
      <p class="font-medium">{{ customer.banks[0].accountHolder }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.numberOfBankAccount') }}</p>
      <p class="font-medium">{{ customer.banks[0].accountNumber }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.loanLimit') }}</p>
      <p class="font-medium">{{ customer.amount | currency }}</p>
    </div>
    <CustomerIncreaseLimit
      v-if="customer"
      :modal-id="modalId"
      :old-amount="customer.amount"
      :customer-id="customer.id"
    />
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';
import CustomerIncreaseLimit from '@/components/customer/CustomerIncreaseLimit';

export default {
  props: {
    customer: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modalId: 'customer-increase-limit-modal',
    };
  },

  methods: {
    showModal() {
      cash(`#${this.modalId}`).modal('show');
    },
  },

  components: {
    Panel,
    CustomerIncreaseLimit,
  },
};
</script>
